import type { ColumnType } from '@deckspace/types';
import { getFieldTypeUI } from '../field-type-ui-registry.js';

/**
 * Format a value for display given its column type and metadata.
 * Used by chart components and EditableCell for value rendering.
 * Delegates to the UI field type registry.
 */
export function formatUnitValue(
  value: unknown,
  type: ColumnType,
  currency?: string,
  unit?: string
): string {
  return getFieldTypeUI(type).format(value, { currency, unit });
}
